import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'

import { selectIsRefreshVipInfo } from '../store/selectors'
import { setLevelAttrs, updateUser } from '../store/userslice'
import { setIsRefreshVipInfo } from '../store/appslice'

import { useAccount } from './useAccount'
import { useUserBasicInfo } from './useUserInfo'
import { useUserVipInfo } from './useUserVipLevel'

const useInitUser = () => {
  const { userId } = useAccount()
  const isRefreshVipInfo = useSelector(selectIsRefreshVipInfo)
  const { userInfo } = useUserBasicInfo()
  const dispatch = useDispatch()
  const { vipInfo, refetch } = useUserVipInfo({ queryUserId: userId, enable: true })

  useEffect(() => {
    if (userId && dispatch) {
      dispatch(updateUser({ userId }))
    }
  }, [userId, dispatch])

  useEffect(() => {
    if (userInfo) {
      dispatch(updateUser(userInfo))
    }
  }, [dispatch, userInfo])

  useEffect(() => {
    if (vipInfo) {
      dispatch(setLevelAttrs(vipInfo))
    }
  }, [vipInfo, dispatch])
  // update vip info
  useEffect(() => {
    if (isRefreshVipInfo) {
      refetch()
      dispatch(setIsRefreshVipInfo(false))
    }
  }, [isRefreshVipInfo, refetch, dispatch])
}

export default useInitUser
